'use client'

import { IntlProvider } from 'react-intl'

type Props = {
  children: React.ReactNode
}

const ContentSectionLayoutSkeletonWrapper = ({ children }: Props) => {
  return (
    <IntlProvider
      locale="en"
      messages={{
        'item.gallery.a11y.current_order_position': 'Current order position',
        'item.gallery.a11y.modal.actions.close': 'Close',
      }}
    >
      {children}
    </IntlProvider>
  )
}

export default ContentSectionLayoutSkeletonWrapper
